import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 17c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7V1H5v4H1v2h4v10zm14-2V7c0-1.1-.9-2-2-2H9v2h8v8h2z"
}), 'CropTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropTwoTone.js
// module id = 3042
// module chunks = 2